import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import styled from 'styled-components';
import bg from '../../assets/img/introBg.png';

const Intro = () => {
  return (
    <HelmetProvider>
      <IntroSection>
        <Helmet>
          <title>TOPPING - Your Service Safety and Value</title>
          <meta name="description" content="당신의 서비스에 안전과 가치를 더하세요. TOPPING은 서비스의 안전성과 가치를 높여주는 솔루션을 제공합니다." />
          <meta name="keywords" content="TOPPING, 토핑, 서비스 안전, 서비스 가치, 솔루션" />
          <meta property="og:title" content="TOPPING - Your Service Safety and Value" />
          <meta property="og:description" content="당신의 서비스에 안전과 가치를 더하세요. TOPPING은 서비스의 안전성과 가치를 높여주는 솔루션을 제공합니다." />
          <meta property="og:type" content="website" />
        </Helmet>
        <div className='action'>
          <p className='introText'>당신의 서비스에 안전과 가치를 더하세요.</p>
          <h1 className='introTitle'>
            Your service safety and value<br />
            Do you more.
          </h1>
        </div>
      </IntroSection>
    </HelmetProvider>
  );
};

const IntroSection = styled.section`
  background-image: url(${bg});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: rgba(0,0,0,0.6);
  background-blend-mode: multiply;
  .action{
    margin-top: -30px;
  }
  .introText{
    margin-bottom: 20px;
  }
`;

export default Intro;
